<template>
<!-- 工作机会 -->
    <div>
        <div class="jobOpportunities">
            <!-- 图片 -->
            <div class="topImg"> 
                <span>
                    人才招聘
                </span>
            </div>
            <!-- 招聘信息 -->
            <div class="recruitInfo">
                <table>
                    <tr class="header">
                        <th>岗位名称</th>
                        <!-- <th>岗位职责</th> -->
                        <th>工作经验</th>
                        <th>学历要求</th>
                        <th>工作地点</th>
                        <th>我要应聘</th>
                    </tr>
                    <tr class="contentTr" v-for="(item,index) in ListJoinUs" :key="index">
                        <td>{{item.jobTitle}}</td>
                        <!-- <td><span v-html="item.jobDuty"></span></td> -->
                        <td>{{item.workExperienceMin}}-{{item.workExperienceMax}}</td>
                        <td>{{item.educationalRequirementsName}}</td>
                        <td>{{item.workCity}}</td>
                        <td>
                            <span class="apply" @click="apply(item.id,index,item.jobTitle)">申请</span>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="pagination">
                <div class="block">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="10"
                        layout="prev, pager, next"
                        :total="count">
                    </el-pagination>
                </div>
            </div>
        </div>
        <!-- 岗位信息 -->
        <el-dialog :visible.sync="dialogFormVisible" class="personalInfo">
            <div class="personalTitle">{{title}}</div>
            <div class="timeDesc">
                <span>工作地点：上海</span>
                <span class="span1">发布时间：2023-04-20</span>
            </div>
            <div class="jobDesc">
                <div>【岗位描述】</div>
                <div class="desc">
                    <span v-html="jobDutys"></span>
                </div>
            </div>
            <div class="jobDesc jdtwo">
                <div>【任职要求】</div>
                <div class="desc">
                    <span v-html="clickJoinUs.jobRequirements"></span>
                </div>
            </div>
            <div class="urBtn">
                <span class="upResume" @click="upres">上传简历</span>
                <!-- <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit('form')">提 交</el-button> -->
            </div>
        </el-dialog>
        <el-dialog title="个人信息" :before-close="infoClose" :visible.sync="upResume" class="personalInfo">
            <el-form :model="form" :rules="rules" ref="form">
                <el-form-item label="姓名" class="labelWidth" prop="name">
                    <el-input v-model="form.name" autocomplete="off" class="nameInput"></el-input>
                </el-form-item>
                <el-form-item label="性别" class="labelWidth">
                    <div class="sexBtn">
                        <span :class="form.sex == 0 ? 'spanBack':''" @click="form.sex = 0">女</span>
                        <span :class="form.sex == 1 ? 'spanBack':''" @click="form.sex = 1" class="sexTow">男</span>
                    </div>
                </el-form-item>
                <el-form-item label="期望薪资" class="labelWidth expectedSalary" required>
                    <el-col>
                        <el-form-item prop="expectedSalaryMin">
                            <span>最低</span>
                            <el-input v-model="form.expectedSalaryMin" autocomplete="off" class="expectInput" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item prop="expectedSalaryMax">
                            <span>最高</span>
                            <el-input v-model="form.expectedSalaryMax" autocomplete="off" class="expectInput"></el-input>
                        </el-form-item>
                    </el-col>
                </el-form-item>
                <el-form-item label="简历" class="labelWidth" prop="file">
                    <div class="resume">
                        <!-- <div>
                            <span class="upResume">点击选择文件</span>
                        </div> -->
                            <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                        <el-upload
                            class="upload-demo"
                            action=""
                            :on-change="handleChange"
                            accept=".txt,.doc,.docx,.ppt,.pptx,.pdf,.zip,.rar"
                            :auto-upload="false"
                            :file-list="fileList">
                            <el-button size="small" type="primary" class="upResume">点击上传</el-button>
                        </el-upload>
                        <div><a>支持格式：txt、doc、docx、ppt、pptx、pdf、zip、rar</a></div>
                    </div>
                </el-form-item>
            </el-form>
            <div class="urBtn urBtnTwo">
                <span class="upResume upResumeTwo" @click="submit('form')">投递简历</span>
                <!-- <el-button @click="upResume = false">取 消</el-button>
                <el-button type="primary" >提 交</el-button> -->
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
//getListEthnic 民族
//getListDocType    证件类型
// setSaveJobSeeker     提交求职者信息
// getListNews     查询全部招聘信息
// getListEducationals  学历
import {getListEthnic,getListDocType,setSaveJobSeeker,getListJoinUs,getListEducationals} from '@/api'
// getListNews 查询新闻
import {} from '@/api'


let validateEmail = (rule, value, callback) => {
    if (!value) {
        return callback(new Error("邮箱不能为空！"));
    }
    else {
        // eslint-disable-next-line no-useless-escape
        const reg=/^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
        if(reg.test(value)){
            callback();
        }else {
            return callback(new Error("邮箱格式不正确！"));
        } 
    }
};
var checkPhone = (rule, value, callback) => {
    if (!value) {
        return callback(new Error('手机号不能为空'));
    } else {
        //验证手机号和区号
        const reg =  /\d{3}-\d{8}|\d{4}-\d{7}|^1((34[0-8])|(8\d{2})|(([35][0-35-9]|4[579]|66|7[35678]|9[1389])\d{1}))\d{7}$/
        if (reg.test(value)) {
            callback();
        } else {
            return callback(new Error('请输入正确的联系电话'));
        }
    }
};
export default {
    name: 'YinshiOffcialwebsiteJobOpportunities',

    data() {
        return {
            // 弹窗显示与隐藏   岗位信息
            dialogFormVisible:false,
            // 上传简历
            upResume:false,
            formLabelWidth: '120px',
            // 要提交的表单
            form: {
                name: '',   //名称
                sex: undefined,    //性别
                birthday: '',  //出生日期
                ethnic: '', //民族
                docType: '',    //证件类型
                docNumber: '', //证件号码
                currAddr: '',   //现居住地
                phone: '',  //手机号
                email: '',  //邮箱
                expectedSalaryMin:'',   //最低期望月薪
                expectedSalaryMax: '',  //最高期望月薪
                jobId:'',  //要申请的职位
                file:undefined, //简历
            },
            // 验证
            rules: {
                name: [{ required: true, message: '请输入您的姓名', trigger: 'blur' }],
                file: [{ required: true, message: '请上传您的简历', trigger: 'blur' }],
                email: [{ required: true, validator: validateEmail, trigger: "blur" }],
                phone: [{ required: true, validator: checkPhone, trigger: "blur" }],
                expectedSalaryMin:[{ required: true, message: '请输入您最低的期望薪资', trigger: 'blur' }],
                expectedSalaryMax:[{ required: true, message: '请输入您最高的期望薪资', trigger: 'blur' }]
            },
            // 民族 
            listEthnic:[],
            // 证件类型
            listDocType:[],
            // 要招聘岗位
            ListJoinUs:[],
            // 学历
            ListEducationals:[],
            // 分页
            pageObj:{
                page:1,
                pageSize:10,
            },
            // 总条数
            count:0,
            // 当前点击的岗位描述和任职要求
            clickJoinUs:{},
            // 上传
            fileList:[],
            // 点击申请标题
            title:'',
            // 岗位职责
            jobDutys:'',
        };
    },

    mounted() {
        
    },

    methods: {
        ...mapMutations(['GoTop']),
        // 上传简历
        handleChange(e){
            // let formData = new FormData();
            // formData.append("file", e.raw);
            this.form.file = e.raw
        },
        // 上传简历弹窗
        upres(){
            this.upResume = true
            setTimeout(() => {
                this.dialogFormVisible = false
            }, 100);
        },
        // 每页多少条
        handleSizeChange(val){
            this.pageObj.pageSize = val
            this.selectListJoinUs()
        },
        // 页码
        handleCurrentChange(val){
            this.pageObj.page = val
            this.selectListJoinUs()
        },
        // 申请
        apply(id,idx,title){
            this.dialogFormVisible = true  
            this.form.jobId = id
            this.title = title
            if(this.ListJoinUs[idx].jobRequirements){
                this.ListJoinUs[idx].jobRequirements = '<p>' + this.ListJoinUs[idx].jobRequirements.replace(/ /g, '&nbsp;').replace(/\n|\r\n/g, '</br>') + '<p>'
            }else{
                this.ListJoinUs[idx].jobRequirements = ''
            }
            if(this.ListJoinUs[idx].jobDuty){
                this.jobDutys = '<p>' + this.ListJoinUs[idx].jobDuty.replace(/ /g, '&nbsp;').replace(/\n|\r\n/g, '</br>') + '<p>'
            }else{
                this.jobDutys = ''
            }
            this.clickJoinUs = this.ListJoinUs[idx]
        },
        // 提交
        async submit(form){
            // 关闭弹窗 
            this.$refs[form].validate(async (valid) => {
                if (valid) {
                    let formData = new FormData();
                    Object.keys(this.form).forEach(item => {
                        formData.append(item+'', this.form[item]);
                    })
                    let res = await setSaveJobSeeker(formData);
                    if(res.code == 200){
                        this.$message({ message: '提交成功！我们收到后会及时联系您！', type: 'success' });
                        this.upResume = false
                    }else{
                        this.$message({message: res.msg+'！',type: 'error'});
                    }
                } else {
                    return false;
                }
            });
        },
        // 取消
        infoClose(){
            this.upResume = false
            Object.keys(this.form).forEach(item => {
                this.form[item] = ''
            })
        },
        // 查询民族
        async selectListEthnic(){
            let res = await getListEthnic();
            this.listEthnic = res.data
        },
        // 证件类型
        async selectListDocType(){
            var res = await getListDocType();
            if(res.code == 200){
                this.listDocType = res.data
            }
        },
        // 查询全部招聘信息
        async selectListJoinUs(){
            // 招聘信息
            let res = await getListJoinUs({page:this.pageObj.page,pageSize:this.pageObj.pageSize});
            // 学历信息
            let etl = await getListEducationals()
            if(res.code == 200){
                if(etl.code == 200){
                    res.data.forEach(item => {
                        etl.data.forEach(item2 => {
                            if(item.educationalRequirementsId == item2.id){
                                item.educationalRequirementsName = item2.name
                            }
                        })
                    })
                    this.ListJoinUs = res.data
                    this.count = res.page.count
                }else{
                    this.ListJoinUs = res.data
                    this.count = res.page.count
                }
            }

        },
    },    
    async created(){
        this.$store.state.currentRouter = this.$route.path  //获取当前页面路由
        this.GoTop()
        // 查询民族
        // this.selectListEthnic()
        // 证件类型
        // this.selectListDocType()
        // 查询全部招聘信息
        this.selectListJoinUs()
    }
};
</script>
<style lang="scss">
    .personalInfo{
        .el-dialog__body{
            padding: 10px 50px;
        }
        .el-form{
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
        }
        .labelWidth{
            display: flex;
        }
        .expectedSalary{
            justify-content: space-between;
            .el-form-item__content{
                display: flex;
                .el-form-item__error{
                    margin-left: 43px;
                }
                div{
                    display: flex;
                }
                span{
                    white-space: nowrap;
                    width: 55px;
                    text-align: center;
                }
                input{
                    width: 80px !important;
                }

            }
        }
        .el-form-item__label{
            width: 75px;
            white-space: nowrap;
        }
        // input{
        //     width: 370px;
        // }
    }
</style>
<style lang="scss" scoped>
    // 弹窗标题
    .personalTitle{
        font-size: 24px;
        font-family: Microsoft YaHei, Microsoft YaHei-Bold;
        font-weight: 700;
        text-align: left;
        color: #3b589a;
        line-height: 32px;
    }
    // 时间
    .timeDesc{
        font-size: 16px;
        font-family: Microsoft YaHei, Microsoft YaHei-Regular;
        font-weight: 400;
        color: #b7b7b7;
        line-height: 32px;
        padding: 8px 0px;
        .span1{
            margin-left: 30px;;
        }
    }
    // 岗位描述
    .jobDesc{
        font-size: 16px;
        font-family: Microsoft YaHei, Microsoft YaHei-Regular;
        font-weight: 400;
        color: #555555;
        .desc{
            margin-left: 5px;
            margin-top: 4px;
            line-height: 30px;
        }
    }
    // 岗位描述
    .jdtwo{
        margin-top: 23px;
    }
    // 上传简历按钮
    .urBtn{
        padding: 100px 0px 60px 0px;
        text-align: center;
    }
    // 按钮样式
    .upResume{
        font-size: 16px;
        font-family: Microsoft YaHei, Microsoft YaHei-Regular;
        font-weight: 400;
        padding: 10px 30px;
        color:#fff;
        background: #3b589a;
        border-radius: 5px;
        cursor: pointer;
        transition: .3s;
    }
    .upResume:hover{
        background: #3b579ad7;
    }
    // 投递简历按钮
    .upResumeTwo{
        border-radius: 21px !important;
        background: #fff !important;
        font-family: Microsoft YaHei, Microsoft YaHei-Regular;
        font-weight: 400;
        text-align: left;
        color: #555555 !important;
        border:1px solid #ddd; 
    }
    .upResumeTwo:hover{
        border:1px solid transparent; 
        background: #3b589a !important;
        color:#fff !important;
    }
    // 岗位
    .jobOpportunities{
        // 顶部图片
        .topImg{
            background: url(../assets/img/gongzuojihui.jpg);
        }
        // 职位表
        .recruitInfo{
            padding:70px 270px 50px 270px;
            display: flex;
            justify-content: center;
            table{
                width: 100%;
                .contentTr{
                    cursor: pointer;
                    transition: .3s;
                }
                // 表头
                .header{
                    th{
                        width:230px;
                        height: 54px;
                        background: #3b589a;
                        text-align: center;
                        color: #ffffff;
                        font-size: 18px;
                        font-family: Microsoft YaHei, Microsoft YaHei-Bold;
                        font-weight: 700;
                        border-left: 1px solid #fff;
                    }
                }
                // 内容
                td{
                    padding:20px 0;
                    border-bottom:1px solid #e2e2e2;
                    font-size: 16px;
                    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                    font-weight: 400;
                    text-align: center;
                    color: #666666;
                }
                .contentTr:hover{
                    background: rgb(242, 242, 242);
                }
            }

        }
        // 分页
        .pagination{
            padding: 0px 270px 70px 270px;
            text-align: center;
        }
    }
    // 提示
    .infoTitle{
        padding: 20px 10px;
        width: 100%;
        border-bottom: 1px solid #eee;
    }
    // 性别按钮
    .sexBtn{
        display: flex;
        justify-content: space-between;
        span{
            border:1px solid #ddd;
            padding: 0px 20px;
            border-radius: 4px;
            cursor: pointer;
            transition: .2s;
        }
        .sexTow{
            margin-left: 10px;
        }
        span:hover{
            border:1px solid #409eff;
            color:#409eff;
        }
        .spanBack{
            background:#409eff;
            color:#ffffff !important;
        }
    }
    // 姓名文本框
    .nameInput{
        width: 107px !important;
    }
    // 薪资
    .expectInput{
        width: 80px !important;
    }
    // 简历
    .resume{
        margin-top: 10px;
        border:1px solid #dcdfe6;
        width: 782px;
        padding: 20px 0px 10px 0px;
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .upload-demo{
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
        a{
            font-size: 16px;
            font-family: Microsoft YaHei, Microsoft YaHei-Regular;
            font-weight: 400;
            color: #acacac;
        }
    }
    // 投递简历按钮
    .urBtnTwo{
        padding: 40px 0px 60px 0px !important;
    }
    .apply{
        border:1px solid #7492d7;
        font-size: 16px;
        border-radius: 16px;
        font-family: Microsoft YaHei, Microsoft YaHei-Bold;
        font-weight: 700;
        color: #7492d7;
        padding:6px 20px;
        transition:.2s;
    }
    .apply:hover{
        background: #7492d7;
        color:#fff;

    }
</style>